import React, { useEffect, useState, useContext } from 'react'
import ListingTableView from '@/custom/components/organisms/Product/TableView'
import { Button } from '@mui/material'
import Layout from '@/product/components/templates/Layout'
import ReportContext from '@/product/context/report/reportContext'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import DynamicBulkListing from '@/product/components/organisms/BulkUpload/ProjectUpload'
import MakeOffer from './MakeOffer'
import Comments from '../Comments/Comments'
import { handleRedirectInternal } from '@/custom/common/components'
import { useHistory } from 'react-router-dom'
import commonContext from '@/product/context/common/commonContext'
import NotesPopup from '@/views/notes/user'

const ListingCommon = (props) => {
    const dynamicContext = useContext(DynamicContext)
    const dashboardContext = useContext(commonContext)
    const { getMainDashboardData } = dashboardContext
    const { project_tablefields } = dynamicContext

    const { getAllExportDownload } = useContext(ReportContext)

    const [searchInfo, setSearchInfo] = useState({})
    const [tableValue, setTableValue] = useState([])
    const [manage, setManage] = useState({
        popup: false,
        status: 'new',
        id: 0,
        projectType: 0,
    })
    const [manageNotes, setManageNotes] = useState({
        popup: false,
        status: 'new',
        id: 0,
        projectType: 0,
    })
    const [bulkPopup, setBulkPopup] = useState(false)
    const toggleBulkPopup = (popup) => {
        setBulkPopup({ popup })
    }
    const history = useHistory()
    const onClickEdit = (id, secondaryID, type) => {
        if (type === 'edit') {
            handleRedirectInternal(history, `listing/edit/${id}`)
        }
    }
    const onClickInvoiceEdit = (id, secondaryID, type) => {
        handleRedirectInternal(history, `invoice/view/${id}/${secondaryID}`)
    }

    const onClickComparisionEdit = (id, secondaryID, type) => {
        if (id) {
            window.open(
                `${process.env.REACT_APP_FRONT_URL}/product/view/${id}/${secondaryID}`,
                '_blank'
            )
        }
    }

    const toggleFullScreenPopup = (popup, status, id, projectType) => {
        if (popup && (status == 'new' || status == 'edit')) {
            handleRedirectInternal(history, `listing/${status}/${id}`)
        } else if (popup && status == 'add_notes') {
            setManageNotes({ popup, status: 'viewListing', id, projectType })
        } else if (popup) {
            setManage({ popup, status, id, projectType })
        } else {
            setManage({ popup, status: 'new', id: 0 })
        }
    }
    const searchparam = new URLSearchParams(props?.location?.search)
    const projectID = searchparam.get('project_id')

    let action = props.match.params.action
    let actionId = props.match.params?.id ? props.match.params?.id : null

    const custom = {
        action: {
            value: action
                ? action.toString() !== 'all'
                    ? action.toString() == 'escalate'
                        ? 'draft'
                        : action.toString() == 'event'
                        ? 'draft'
                        : action.toString()
                    : 'review'
                : null,
            type: action.toString() !== 'all' ? 'in' : 'notin',
            field: 'p.market_status',
        },
        // actions: {
        //     value: action
        //         ? action.toString() == 'all'
        //             ? 'removed'
        //             : ''
        //         : null,
        //     type: action.toString() == 'all' ? 'notin' : 'in',
        //     field: 'p.market_status',
        // },
        actions: {
            value: '',
            type: 'in',
            field: 'p.market_status',
        },

        escalate: {
            value: action
                ? action.toString() === 'escalate'
                    ? 1
                    : action.toString() === 'draft'
                    ? '0'
                    : ''
                : '',
            type: 'in',
            field: 'it.escalate',
        },
        actionid: {
            value:
                action?.toString() == 'event'
                    ? '0'
                    : action.toString() === 'draft'
                    ? '0'
                    : '',
            type: action?.toString() == 'event' ? 'notin' : 'in',
            field: 'p.auctionid',
        },
        projectid: {
            value: projectID ? projectID : '',
            type: 'in',
            field: 'p.id',
        },
    }

    useEffect(() => {
        if (project_tablefields && project_tablefields.length) {
            let dynamicValueAssign = {}
            let searchData = project_tablefields.map((el) => {
                if (el.field === 'username') {
                    el.class = 'col-3'
                }
                if (el.field === 'id') {
                    el.table_search = 1
                    el.sort_field = ''
                    el.class = 'col-3'
                    el.label = 'Product ID'
                    el.filter_type = 'in'
                    el.filter = true
                    el.is_default = 1
                    el.diff_sort = 1
                }
                if (el.field === 'status') {
                    el.table_search = 0
                    // el.type = 'select'
                    // el.class = 'col-3'
                }

                // Return the modified element (whether modified or not)
                return el
            })
            searchData.push({
                field: 'winner_username',
                active: 1,
                table_search: 1,
                label: 'Won By Username / Email',
                name: 'winner_username',
                filter_type: 'like',
                filterField: 'bnu.username,bnu.email',
                type: 'text',
                view_page: '1',
            })
            if (props.match.params.action == 'all') {
                searchData.push({
                    field: 'box_code',
                    active: 1,
                    table_search: 1,
                    label: 'Box Code',
                    name: 'box_code',
                    class: 'col-3',
                    filter_type: 'like',
                    filterField: 'it.box_code',
                    type: 'text',
                    view_page: '1',
                })
                searchData.push({
                    field: 'serial_number',
                    active: 1,
                    table_search: 1,
                    label: 'Serial Number',
                    class: 'col-3',
                    name: 'serial_number',
                    filter_type: 'like',
                    filterField: 'it.serial_number',
                    type: 'text',
                    view_page: '1',
                })
            }
            if (
                props.match?.params?.action == 'draft' ||
                props.match?.params?.action == 'escalate' ||
                props.match?.params?.action == 'event'
            ) {
                searchData.push({
                    field: 'maker_country',
                    active: 1,
                    table_search: 1,
                    label: 'Origin',
                    name: 'maker_country',
                    class: 'col-3',
                    filter_type: 'in',
                    filter: true,
                    filterField: 'it.maker_country',
                    view_page: '1',
                    type: 'select',
                    search: 1,
                    options: [
                        // { value: '', show: 'All', id: '' },
                        { value: 'Cuba', show: 'Cuba', id: 'Cuba' },
                        {
                            value: 'New World',
                            show: 'New World',
                            id: 'New World',
                        },
                    ],
                })
            }

            dynamicValueAssign.data = searchData

                .filter((item) => item?.table_search === 1) // Filter the items based on table_search being 1
                .map((buscat) => {
                    // Conditionally set field when name matches
                    if (buscat.field === 'as_employees_username') {
                        buscat.filterField = 'e.username' // Set buscat.field to 'e.username'
                        buscat.field = 'username' // Set buscat.field to 'e.username'
                    }
                    if (buscat.field === 'as_employees_emp_email') {
                        buscat.filterField = 'e.emp_email' // Set buscat.field to 'e.username'
                        buscat.field = 'emp_email'
                    }

                    // Return the updated buscat object, merging with a new `name` property
                    return {
                        ...buscat, // Spread the buscat object to keep other properties intact
                        name: buscat.field, // Set the name property to the field value
                    }
                })
            setSearchInfo(dynamicValueAssign)
            let dynamicAssign = [...project_tablefields]

            // Modify fields
            dynamicAssign.forEach((data) => {
                if (data.field === 'auctiontitle') {
                    data.click = true
                    data.onclick = onClickEdit
                    data.clickID = 'id'
                    data.secondaryClickID = 'user_id'
                    data.clickType = 'edit'
                    data.type = 'text'
                }

                if (data.field === 'emp_email') {
                    data.field = 'as_employees_emp_email'
                }

                if (data.field === 'username') {
                    data.field = 'as_employees_username'
                }

                if (data.field === 'comparison_item') {
                    data.click = true
                    data.onclick = onClickComparisionEdit
                    data.clickID = 'comparison_id'
                    data.secondaryClickID = 'comparison_item'
                    data.clickType = 'edit'
                    data.type = 'hyperlink'
                }

                if (
                    data.field === 'check_box_code_valid' ||
                    data.field === 'serial_number_valid' ||
                    data.field === 'serial_number_habanos_valid' ||
                    data.field === 'band_valid' ||
                    data.field === 'source_valid' ||
                    data.field === 'ribbon_valid' ||
                    data.field === 'insert_valid' ||
                    data.field === 'box_valid' ||
                    data.field === 'price_valid'
                ) {
                    data.type = 'statusIcon'
                }

                if (data.field === 'market_status') {
                    data.click = true
                    data.onclick = onClickEdit
                    data.clickID = 'id'
                    data.secondaryClickID = 'user_id'
                    data.clickType = 'edit'
                    data.type = 'singleSelect'
                    data.valueOptions = [
                        { value: 'open', label: 'Open' },
                        { value: 'closed', label: 'Closed' },
                        { value: 'sold', label: 'Sold' },
                        { value: 'unsold', label: 'Unsold' },
                        { value: 'draft', label: 'Moderate' },
                        { value: 'reject', label: 'Disapproved' },
                        { value: 'relisted', label: 'Relisted' },
                        { value: 'removed', label: 'Deleted' },
                    ]
                }

                if (data.field === 'buynow_common_invoice') {
                    data.click = true
                    data.onclick = onClickInvoiceEdit
                    data.clickID = 'buynow_common_invoice'
                    data.secondaryClickID = 'buynow_user_id'
                    data.clickType = 'edit'
                    data.type = 'hyperlink'
                }
                if (data.field === 'totalNotesCount') {
                    data.click = true
                    data.onclick = onClickNotesview
                    data.clickID = 'id'
                    data.clickType = 'edit'
                    data.secondaryClickID = 'seller_id'
                    data.type = 'hyperlink'
                }
            })

            setTableValue(dynamicAssign)
        }
        const filterBody = {
            filterRange: true,
            search: 'within',
            within: 'month',
        }
        getMainDashboardData(filterBody)
    }, [project_tablefields, action])

    const toggleNotesAddedScreenPopup = (popup, status, id, projectType) => {
        setManageNotes({ popup, status: 'updated', id: 0, projectType: 0 })
    }
    const onClickNotesview = (id, sellerId) => {
        setManageNotes({
            popup: true,
            status: 'viewListing',
            id,
            sellerId,
            projectType: 0,
        })
    }
    return (
        <>
            <Layout>
                <div className="dashboard listing maillisting">
                    <ListingTableView
                        searchInfo={searchInfo}
                        customFilter={custom}
                        tableValue={tableValue}
                        show_maxbid={true}
                        show_declined={true}
                        show_tiebid={true}
                        manageNotes={manageNotes?.status}
                        toggleFullScreenPopup={toggleFullScreenPopup}
                        tableActionString={[
                            'open',
                            // 'date_closed',
                            'removed',
                            'unsold',
                            'relist',
                            'reject',
                            // 'auction_assign'
                        ]}
                        listActionString={[
                            'bidcount',
                            // 'makeoffer',
                            'questions',
                            'audit_trail',
                            'disapproval',
                            'post-sale-update',
                            'add_notes',
                        ]}
                        action={action}
                        disapproval={true}
                        preview={true}
                    />
                </div>
                <NotesPopup
                    data={manageNotes}
                    function={toggleNotesAddedScreenPopup}
                />

                {/* <MakeOffer data={manage} function={toggleFullScreenPopup} /> */}
                <Comments data={manage} function={toggleFullScreenPopup} />
                <DynamicBulkListing
                    data={bulkPopup}
                    function={toggleBulkPopup}
                    ignoreFields={
                        global?.bulk_ignoreFields
                            ? global.bulk_ignoreFields
                            : []
                    }
                />
            </Layout>
        </>
    )
}

export default ListingCommon
